import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Register } from '../../_models/register';
import { Inventory } from '../../inventory';
import { KitComponent } from '../../_models/kitComponent';
import { ProductAttribute } from '../../_models/productAttribute';
import { Subject } from 'rxjs';
import { Product } from '../../_models/product';
import { Caller } from '../../_models/caller';
import { AlertService } from '../../_services/alert.service';
import * as _ from "lodash";

@Component({
  selector: 'app-seller-products-edit',
  templateUrl: './seller-products-edit.component.html',
  styleUrls: ['./seller-products-edit.component.scss'],
})
export class SellerProductsEditComponent implements OnInit {
  productTemp: Product = {};
  kitComponent: KitComponent = {};
  tabClicked: string;
  productImage: string = "/assets/images/default-product.png";
  uploadImage: string;
  onHandQuantityRecords: any;
  kitComponents: any[] = [];
  products: any[] = [];
  statusText: string = "";
  imageUrl: string;
  productsErrorMessage: any[] = [];
  successMessage: any[] = [];
  productType: string;
  step: number = 1;
  selectedComponents: any[] = [];
  regularProducts: any[] = [];
  productAttr: ProductAttribute = {
    digitalProduct: "",
    lotProduct: "",
    productNumberScans: "",
    dangerousGood: "",
    wholeCaseProduct: "",
    foldableProduct: "",
    bubbleMailer: "",
    fragileProduct: "",
    essentialGoods: "",
    PolyMailer: ""
  };
  editInventory: Inventory = {
    barCode: "",
    imageUrl: "",
    productImage: "",
    productName: "",
    productType: "",
    productAttributes: "",
    status: "",
    storeSku: "",
    weight: "",
    hsnCode: "",
    sku: "",
    minQuantity: "",
    rackLocation: "",
    binLocation: "",
    accountOwners: "",
    kitComponents: "",
    products: "",
    productId: 0,
    id: 0,
    dimensions: "",
    accountOwnerId: 0,
    organizationId: 0
  };
  statusText1: string = "";
  statusText2: string = "";
  statusText12: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText6: string = "";
  hsnCodeError: string = "";
  lengthError: string = "";
  minQuantityError: string = "";
  imageUrlError: string = "";
  selectedProducts = [];
  productsList: any;
  productView: any = {};
  length: any;
  width: any;
  height: any;
  value: any;
  id: any;
  productLines: any;
  quantity: any;
  category: any = {};
  categories: any;
  variantError: string;
  colorError: string;
  categoryError: string;

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, public route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User, public register: Register, public caller: Caller) {
    this.g.page = "Edit Product";
    this.id = this.route.snapshot.params['id'];
    this.g.loaderDisplay = "display";
    if (this.id) {

      this.g.loaderDisplay = "display";
      this.api.getProductListByProductId(this.id, this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.editInventory = data;
        this.getAllProductCategory();

        if (this.editInventory.productType === 'KIT') {
          this.api.getProductsByProductType("1", this.user.accountOwnerId, "REGULAR", "ACTIVE").subscribe((data: any) => {
            this.g.loaderDisplay = "";
            this.regularProducts = data.getProductsResponses;

          }, err => {
            console.log(err);
            this.g.loaderDisplay = "";
          });
        }

        this.productLines = _.cloneDeep(this.editInventory.kitComponents);
        if (data.dimensions != null) {
          this.length = data.dimensions.split("*")[0];
          this.width = data.dimensions.split("*")[1];
          this.height = data.dimensions.split("*")[2];
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("digitalProduct=true") === -1) {
        } else {
          this.productAttr.digitalProduct = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("lotProduct=true") === -1) {
        } else {
          this.productAttr.lotProduct = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("essentialGoods=true") === -1) {
        } else {
          this.productAttr.essentialGoods = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("productNumberScans=true") === -1) {
        } else {
          this.productAttr.productNumberScans = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("dangerousGood=true") === -1) {
        } else {
          this.productAttr.dangerousGood = "true";
        }

        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("wholeCaseProduct=true") === -1) {
        } else {
          this.productAttr.wholeCaseProduct = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("foldableProduct=true") === -1) {
        } else {
          this.productAttr.foldableProduct = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("bubbleMailer=true") === -1) {
        } else {
          this.productAttr.bubbleMailer = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("fragileProduct=true") === -1) {
        } else {
          this.productAttr.fragileProduct = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("PolyMailer=true") === -1) {
        } else {
          this.productAttr.PolyMailer = "true";
        }
        if (this.editInventory.productAttributes === null
          || this.editInventory.productAttributes === ""
          || this.editInventory.productAttributes.indexOf("dangerousGood=true") === -1) {
        } else {
          this.productAttr.dangerousGood = "true";
        }
      }, err => {
        this.alertService.error('Error', err);
        this.g.loaderDisplay = "";
      });
    }

    this.tabClicked = "attributes";

  }

  selectedOnHandQuantity(records) {
    this.onHandQuantityRecords = records;
  }


  getAllProductCategory() {
    this.api.getAllProductSeller(this.editInventory.accountOwnerId, this.editInventory.organizationId).subscribe((data: any) => {
      this.categories = data;
      for (let cat of this.categories) {
        if (cat.id === this.editInventory.categoryId) {
          this.category = cat;
          console.log(this.category);
        }

      }

    }, err => {
      this.alertService.error('Error', err);
    });
  }

  typeCategory() {
    this.categoryError = "";
    if (this.editInventory.categoryName == '' || this.editInventory.categoryName === null || this.editInventory.categoryName === undefined || this.editInventory.categoryName === 'undefined') {
      this.categoryError = 'Please select category';
    }
  }

  typeColor() {
    this.colorError = "";
    if (!this.editInventory.productColor) {
      this.colorError = 'Please enter color';
    }
  }

  typeVariant() {
    this.variantError = "";
    if (!this.editInventory.productVariant) {
      this.variantError = 'Please enter variant';
    }
  }

  /*
       removeExistingComponents() {
          for (let sc of this.selectedComponents) {
             for (let rp of this.regularProducts) {
                if (rp.productId === sc.childProductId) {
                   let index = this.regularProducts.indexOf(rp);
                   this.regularProducts.splice(index,1);
                }
             }
          }
       }
  */
  productSelected() {
    if (this.productTemp != null && this.productTemp != undefined && this.productTemp.productName !== null && this.productTemp.productName !== undefined) {
      this.kitComponent.productName = this.productTemp.productName;
      this.kitComponent.sku = this.productTemp.sku;
      this.kitComponent.quantity = this.quantity;
      this.kitComponent.childProductId = this.productTemp.productId;
      this.productLines.push(_.cloneDeep(this.kitComponent));
      this.productTemp = null;
      this.quantity = 1;
    }
  }

  addComponentToKit() {
    this.statusText3 = "";
    for (let p of this.productLines) {
      if (p.quantity == '' || p.quantity === null || p.quantity === undefined || p.quantity === 'undefined' || p.quantity <= 0) {
        this.statusText3 = 'Please enter quantity minimum as 1';
        return false;
      }
    }
    this.editInventory.kitComponents = _.cloneDeep(this.productLines);
    this.backToProduct();
  }

  removeProduct(rp) {
    let index = this.productLines.indexOf(rp);
    this.productLines.splice(index, 1);
  }

  saveProduct() {
  }

  productSearch(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.productName.toLowerCase().indexOf(term) > -1 || (item.sku && item.sku.toLowerCase().indexOf(term) > -1);
  }

  ngOnInit(): void {
  }

  tabChange(tab) {
    this.tabClicked = tab
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.ignoreImage();
        this.editInventory.imageUrl = data['message'];
      } else {
        this.ignoreImage();
        this.editInventory.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.ignoreImage();
      });
  }

  switchToComponents() {
    this.tabClicked = 'add';
  }

  backToProduct() {
    this.step = 1;
  }

  submitEditProducts(productType) {
    this.editInventory.dimensions = this.length + "*" + this.width + "*" + this.height;
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText4 = "";
    this.minQuantityError = "";
    this.hsnCodeError = "";
    this.lengthError = "";
    //this.rackLocationError="";
    this.categoryError = "";
    this.colorError = "";
    this.variantError = "";

    if (this.productLines.length === 0) {
      this.lengthError = 'Please select product';
    }

    if (this.editInventory.productName == '' || this.editInventory.productName === null || this.editInventory.productName === undefined || this.editInventory.productName === 'undefined') {
      this.statusText1 = 'Please enter productName';
    }
    if (this.editInventory.minQuantity == '' || this.editInventory.minQuantity === null || this.editInventory.minQuantity === undefined || this.editInventory.minQuantity === 'undefined') {
      this.minQuantityError = 'Please enter Min Quantity';
    }
    /*if (this.editInventory.rackLocation == '' || this.editInventory.rackLocation === null|| this.editInventory.rackLocation === undefined|| this.editInventory.rackLocation === 'undefined') {
    this.rackLocationError = 'Please enter rackLocation';
          }*/

    if (!this.editInventory.hsnCode) {
      this.hsnCodeError = 'Please enter HSN Code';
    }

    if (this.editInventory.categoryName == '' || this.editInventory.categoryName === null || this.editInventory.categoryName === undefined || this.editInventory.categoryName === 'undefined') {
      this.categoryError = 'Please select category';
    }
    if (this.editInventory.productColor == '' || this.editInventory.productColor === null || this.editInventory.productColor === undefined || this.editInventory.productColor === 'undefined') {
      this.colorError = 'Please enter color';
    }
    if (this.editInventory.productVariant == '' || this.editInventory.productVariant === null || this.editInventory.productVariant === undefined || this.editInventory.productVariant === 'undefined') {
      this.variantError = 'Please enter variant';
    }
    for (let p of this.productLines) {
      if (p.quantity == '' || p.quantity === null || p.quantity === undefined || p.quantity === 'undefined' || p.quantity <= 0) {
        this.statusText4 = 'Please enter quantity minimum as 1';
      }
    }
    if (this.categoryError != "" || this.colorError != "" || this.variantError != "" || this.statusText1 != "" || this.statusText2 != "" || this.statusText4 != "" || this.minQuantityError != "" || this.hsnCodeError != "" || this.lengthError != "") {
      return false;
    }
    var buildProductAttributeString = "";
    if (this.productAttr.digitalProduct) {
      buildProductAttributeString = buildProductAttributeString + "digitalProduct=true|";
    }
    if (this.productAttr.lotProduct) {
      buildProductAttributeString = buildProductAttributeString + "lotProduct=true|";
    }
    if (this.productAttr.essentialGoods) {
      buildProductAttributeString = buildProductAttributeString + "essentialGoods=true|";
    }
    if (this.productAttr.dangerousGood) {
      buildProductAttributeString = buildProductAttributeString + "dangerousGood=true|";
    }
    if (this.productAttr.productNumberScans) {
      buildProductAttributeString = buildProductAttributeString + "productNumberScans=true|";
    }
    if (this.productAttr.wholeCaseProduct) {
      buildProductAttributeString = buildProductAttributeString + "wholeCaseProduct=true|";
    }
    if (this.productAttr.foldableProduct) {
      buildProductAttributeString = buildProductAttributeString + "foldableProduct=true|";
    }
    if (this.productAttr.bubbleMailer) {
      buildProductAttributeString = buildProductAttributeString + "bubbleMailer=true|";
    }
    if (this.productAttr.fragileProduct) {
      buildProductAttributeString = buildProductAttributeString + "fragileProduct=true|";
    }
    if (this.productAttr.PolyMailer) {
      buildProductAttributeString = buildProductAttributeString + "PolyMailer=true|";
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateProduct', {
      "accountOwnerId": this.editInventory.accountOwnerId,
      "productId": this.id,
      "organizationId": 1,
      "barCode": this.editInventory.barCode,
      "dimensions": this.editInventory.dimensions,
      "imageUrl": this.editInventory.imageUrl,
      "productName": this.editInventory.productName,
      "productType": this.editInventory.productType,
      "productAttributes": buildProductAttributeString,
      "sku": this.editInventory.sku,
      "status": this.editInventory.status,
      "storeSku": this.editInventory.storeSku,
      "weight": this.editInventory.weight,
      "hsnCode": this.editInventory.hsnCode,
      "binLocation": this.editInventory.binLocation,
      "rackLocation": this.editInventory.rackLocation,
      "sellerId": this.user.sellerId,
      "minQuantity": this.editInventory.minQuantity,
      "categoryId": this.category.id,
      "productColor": this.editInventory.productColor,
      "productVariant": this.editInventory.productVariant
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (productType === 'KIT') {
          this.http.post(environment.apiUrl + 'api/updateKitComponent', {
            "organizationId": 1,
            "parentProductId": this.id,
            "compRequests": this.productLines
          },
            { headers: header1 }).subscribe(data => {
              this.g.loaderDisplay = "";
              if (data['code'] == 200) {
                this.alertService.success('Product', 'Edited Successfully');
                this.router.navigate(['/admin/sellerProductsList']);
              } else {
                this.alertService.error('Error', data['message']);
              }
            },
              (err: HttpErrorResponse) => {
                this.g.loaderDisplay = "";
              });
        } else {
          if (data['code'] == 200) {
            this.alertService.success('Kit', 'Edited Successfully');
            this.router.navigate(['/admin/sellerProductsList']);
          } else {
            this.alertService.error('Error', data['message']);
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }

  /*typeRackLocation(){
    this.rackLocationError ="";
    if (this.editInventory.rackLocation == '' || this.editInventory.rackLocation === null|| this.editInventory.rackLocation === undefined || this.editInventory.rackLocation === 'undefined') {
      this.rackLocationError = 'Please enter rackLocation';
    }
  }*/

  typeProduct() {
    this.statusText1 = "";
    if (this.editInventory.productName == '' || this.editInventory.productName === null || this.editInventory.productName === undefined || this.editInventory.productName === 'undefined') {
      this.statusText1 = 'Please enter productName';
    }
  }

  typeStoreSku() {
    this.statusText12 = "";
    if (this.editInventory.storeSku == '' || this.editInventory.storeSku === null || this.editInventory.storeSku === undefined || this.editInventory.storeSku === 'undefined') {
      this.statusText12 = 'Please enter store SKU';
    } else if (this.editInventory.storeSku.length <= 3) {
      this.statusText12 = 'Store SKU must contain atleast 3-50 characters';
    }
  }

  skuValue() {
    this.editInventory.sku = 'SFT' + this.editInventory.storeSku + this.user.accountOwnerId + this.user.sellerId;
  }

  typeMinQuantity() {
    this.minQuantityError = "";
    if (this.editInventory.minQuantity == '' || this.editInventory.minQuantity === null || this.editInventory.minQuantity === undefined || this.editInventory.minQuantity === 'undefined') {
      this.minQuantityError = 'Please enter minQuantity';
    }
  }

  typeHsn() {
    this.hsnCodeError = "";
    if (this.editInventory.hsnCode == '' || this.editInventory.hsnCode === null || this.editInventory.hsnCode === undefined || this.editInventory.hsnCode === 'undefined') {
      this.hsnCodeError = 'Please enter hsnCode';
    }
  }

  submitEditRegularProducts(productType) {
    this.editInventory.dimensions = this.length + "*" + this.width + "*" + this.height;
    this.statusText1 = "";
    this.statusText2 = "";
    this.hsnCodeError = "";
    this.minQuantityError = "";
    this.imageUrlError = "";
    //this.rackLocationError="";
    this.categoryError = "";
    this.colorError = "";
    this.variantError = "";

    if (this.editInventory.productName == '' || this.editInventory.productName === null || this.editInventory.productName === undefined || this.editInventory.productName === 'undefined') {
      this.statusText1 = 'Please enter productName';
    }
    if (!this.editInventory.imageUrl && this.productType === 'Sample') {
      this.imageUrlError = 'Please select Image';
    }

    /*if (this.editInventory.rackLocation == '' || this.editInventory.rackLocation === null|| this.editInventory.rackLocation === undefined|| this.editInventory.rackLocation === 'undefined') {
      this.rackLocationError = 'Please Enter rackLocation';
     }*/

    if (this.editInventory.categoryName == '' || this.editInventory.categoryName === null || this.editInventory.categoryName === undefined || this.editInventory.categoryName === 'undefined') {
      this.categoryError = 'Please select category';
    }
    if (this.editInventory.productColor == '' || this.editInventory.productColor === null || this.editInventory.productColor === undefined || this.editInventory.productColor === 'undefined') {
      this.colorError = 'Please enter color';
    }
    if (this.editInventory.productVariant == '' || this.editInventory.productVariant === null || this.editInventory.productVariant === undefined || this.editInventory.productVariant === 'undefined') {
      this.variantError = 'Please enter variant';
    }

    if (this.editInventory.minQuantity == '' || this.editInventory.minQuantity === null || this.editInventory.minQuantity === undefined || this.editInventory.minQuantity === 'undefined') {
      this.minQuantityError = 'Please enter minQuantity';
    }
    if (this.editInventory.hsnCode == '' || this.editInventory.hsnCode === null || this.editInventory.hsnCode === undefined || this.editInventory.hsnCode === 'undefined') {
      this.hsnCodeError = 'Please enter hsnCode';
    }

    if (this.categoryError != "" || this.colorError != "" || this.variantError != "" || this.statusText1 != "" || this.statusText2 != "" || this.hsnCodeError != "" || this.minQuantityError != "" || this.imageUrlError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var buildProductAttributeString = "";
    if (this.productAttr.digitalProduct) {
      buildProductAttributeString = buildProductAttributeString + "digitalProduct=true|";
    }
    if (this.productAttr.lotProduct) {
      buildProductAttributeString = buildProductAttributeString + "lotProduct=true|";
    }
    if (this.productAttr.essentialGoods) {
      buildProductAttributeString = buildProductAttributeString + "essentialGoods=true|";
    }
    if (this.productAttr.dangerousGood) {
      buildProductAttributeString = buildProductAttributeString + "dangerousGood=true|";
    }
    if (this.productAttr.productNumberScans) {
      buildProductAttributeString = buildProductAttributeString + "productNumberScans=true|";
    }
    if (this.productAttr.wholeCaseProduct) {
      buildProductAttributeString = buildProductAttributeString + "wholeCaseProduct=true|";
    }
    if (this.productAttr.foldableProduct) {
      buildProductAttributeString = buildProductAttributeString + "foldableProduct=true|";
    }
    if (this.productAttr.bubbleMailer) {
      buildProductAttributeString = buildProductAttributeString + "bubbleMailer=true|";
    }
    if (this.productAttr.fragileProduct) {
      buildProductAttributeString = buildProductAttributeString + "fragileProduct=true|";
    }
    if (this.productAttr.PolyMailer) {
      buildProductAttributeString = buildProductAttributeString + "PolyMailer=true|";
    }
    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateProduct', {
      "accountOwnerId": this.editInventory.accountOwnerId,
      "productId": this.id,
      "organizationId": 1,
      "barCode": this.editInventory.barCode,
      "dimensions": this.editInventory.dimensions,
      "imageUrl": this.editInventory.imageUrl,
      "productName": this.editInventory.productName,
      "productType": this.editInventory.productType,
      "productAttributes": buildProductAttributeString,
      "sku": this.editInventory.sku,
      "status": this.editInventory.status,
      "storeSku": this.editInventory.storeSku,
      "weight": this.editInventory.weight,
      "hsnCode": this.editInventory.hsnCode,
      "binLocation": this.editInventory.binLocation,
      "rackLocation": this.editInventory.rackLocation,
      "sellerId": this.user.sellerId,
      "minQuantity": this.editInventory.minQuantity,
      "categoryId": this.category.id,
      "productColor": this.editInventory.productColor,
      "productVariant": this.editInventory.productVariant

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (productType === 'KIT') {
          this.http.post(environment.apiUrl + 'api/updateKitComponent', {
            "organizationId": 1,
            "parentProductId": this.id,
            "compRequests": this.editInventory.kitComponents
          },
            { headers: header1 }).subscribe(data => {
              this.g.loaderDisplay = "";
              if (data['code'] == 200) {
                this.alertService.success('Product', 'Edited Successfully');
                this.router.navigate(['/admin/sellerProductsList']);
              } else {
                this.alertService.error('Error', data['message']);
              }
            },
              (err: HttpErrorResponse) => {
                this.g.loaderDisplay = "";
              });
        } else {
          if (data['code'] == 200) {
            this.alertService.success('Product', 'Edited Successfully');
            this.router.navigate(['/admin/sellerProductsList']);
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  submitKitDelete2(comp, i) {
    let index = this.productLines.indexOf(comp);
    this.productLines.splice(index, 1);
  }

  submitKitDelete(comp, i) {
    this.g.loaderDisplay = "";
    if (!comp.id) {
      this.productLines.splice(i, 1);
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItemlocalStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteKitComponents', {
      "id": comp.id,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          /*      let index = this.productLines.indexOf(comp);
               this.productLines.splice(i, 1); */
          this.productLines.splice(i, 1);
        } else {
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  open() {
    this.selectedProducts = _.cloneDeep(this.regularProducts || []);
    for (let i = 0; i < this.productLines.length; i++) {
      let index = this.selectedProducts.findIndex((d) => d.productName === this.productLines[i].productName);
      if (index > -1) {
        this.selectedProducts.splice(index, 1);
      }
    }
  }
}
